import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=6b236f83&scoped=true"
import script from "@/views/Users/Teacher/Teacher.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Teacher/Teacher.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Teacher/teacher.scss?vue&type=style&index=0&id=6b236f83&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b236f83",
  null
  
)

export default component.exports